import { render, staticRenderFns } from "./edittestPaper.vue?vue&type=template&id=10c0e93b&scoped=true&"
import script from "./edittestPaper.vue?vue&type=script&lang=js&"
export * from "./edittestPaper.vue?vue&type=script&lang=js&"
import style0 from "./edittestPaper.vue?vue&type=style&index=0&id=10c0e93b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0e93b",
  null
  
)

export default component.exports